import UserCreditTransferContainer from './user-credit-transfer.container';

export default UserCreditTransferContainer;
